import {Injectable} from '@angular/core';
import {ApiService, JsonResult} from '../core/services/api.service';
import {Observable} from 'rxjs';
import {HandleErrorService} from './handle-error.service';
import {catchError, tap} from 'rxjs/operators';
import Swal from 'sweetalert2';
import {HttpEvent} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BenefitsService {

  constructor(
    private serviceApi: ApiService,
    private handleError: HandleErrorService,
  ) {
  }

  gettingBenefitsModule(location?: number, exactItem?: string): Observable<HttpEvent<JsonResult<any>>> {
    return this.serviceApi.get<any>(
      `Configuration/ConfigurationBenefits${location ? '?Ubigeo=' + location : ''}`
    );
  }

  gettingBenefitsInstitutions(): Observable<HttpEvent<JsonResult<any>>> {
    return this.serviceApi.get<any>(
      `Master/BenefitsInstitution`
    );
  }

  deleteCoupon(couponId: number, categoryId: number): Observable<any> {
    return this.serviceApi.delete(`Benefits/ByIdBenefitsItem/${couponId}/${categoryId}`);
  }

  deleteCategory(categoryId: number): Observable<any> {
    return this.serviceApi.delete(`Benefits/ByIdBenefitsCategory/${categoryId}`);
  }

  deleteInstitution(institutionId: number): Observable<any> {
    return this.serviceApi.delete(`Benefits/ByIdBenefitsInstitution/${institutionId}`);
  }

  createBenefitsCategory(body: any): Observable<any> {
    return this.serviceApi.post<any>(
      `Benefits/BenefitsCategory`, body
    );
  }

  createBenefitsCoupon(body: any): Observable<any> {
    return this.serviceApi.post<any>(
      `Benefits/Coupon`, body
    );
  }

  createBenefitsInstitutions(body: any): Observable<any> {
    return this.serviceApi.post<any>(
      `Benefits/BenefitsInstitution`, body
    );
  }

  updateBenefitsCategory(body: any): Observable<any> {
    return this.serviceApi.put<any>(
      `Benefits/UBenefitsCategory`, body
    );
  }

  updateBenefitsInstitutions(body: any): Observable<any> {
    return this.serviceApi.put<any>(
      `Benefits/UBenefitsInstitution`, body
    );
  }

  updateBenefitsCoupon(body: any): Observable<any> {
    return this.serviceApi.put<any>(
      `Benefits/UCoupon`, body
    );
  }

  switchBenefitCategory(body: any): Observable<any> {
    return this.serviceApi.patch(`Benefits/StatusBenefitsCategory`, body);
  }

  switchBenefitCoupon(couponId: number, categoryId: number): Observable<any> {
    return this.serviceApi.patch(`Benefits/StatusBenefitsItem`, {id: couponId, categoryId: categoryId});
  }

  switchBenefitInstitution(body: any): Observable<any> {
    return this.serviceApi.patch(`Benefits/StatusBenefitsInstitution`, body);
  }

  insertPdf(body): Observable<any> {
    return this.serviceApi.put(`Benefits/UBenefitsDownload`, body)
      .pipe(catchError(this.handleError.catchHttpError),
        tap((data: { valid: boolean, message: string }) => {
          if (data.valid) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Aceptar',
              text: data.message,
            }).then();
          }
        })
      );
  }
}
